import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complianceService } from '../../services/complianceService';

export const useGetAmlCaseDetail = caseId => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.compliance.detail, caseId],
    enabled: !!caseId,
    queryFn: () =>
      complianceService.detail(caseId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }

        throw new Error('Fetch failed');
      }),
  });
};
